import React from 'react';
import './FooterPage.css';

const CookieInfo = () => {
  return (
    <div className="footer-page">
        <div className="footer-page__container">
          <h1>Cookie-Informationen</h1>

          <section>
            <h2>Nutzung von Cookies und ähnlichen Technologien</h2>
            <p>Auf dieser Website werden keine Cookies verwendet.</p>
          </section>

          <section>
            <h2>Speicherung von Einstellungen</h2>
            <p>Um Ihre Nutzererfahrung zu verbessern, speichern wir Ihre Auswahl (1. oder 2. Rugby Bundesliga) im Local Storage Ihres Browsers. Diese Information bleibt auch nach dem Schließen des Browsers erhalten, bis Sie Ihren Local Storage leeren oder die Einstellungen zurücksetzen.</p>
            <p>Diese Daten werden ausschließlich auf Ihrem Gerät gespeichert und nicht an uns oder Dritte übermittelt.</p>
          </section>

          <section>
            <h2>Kontrolle über Ihre Daten</h2>
            <p>Sie können die im Local Storage gespeicherten Informationen jederzeit löschen, indem Sie die Browser-Einstellungen Ihres Geräts anpassen. Bitte beachten Sie, dass dadurch Ihre gespeicherten Einstellungen zurückgesetzt werden.</p>
          </section>

          <section>
            <h2>Änderungen dieser Cookie-Information</h2>
            <p>Wir behalten uns das Recht vor, diese Cookie-Information bei Bedarf anzupassen, um rechtlichen Anforderungen zu entsprechen oder Änderungen unserer Dienste widerzuspiegeln.</p>
          </section>

          <section>
            <h2>Kontakt</h2>
            <p>Bei Fragen zu dieser Cookie-Information können Sie uns über die im Impressum angegebenen Kontaktdaten erreichen.</p>
          </section>
        </div>
    </div>
  );
};

export default CookieInfo;
